"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DATE_FORMAT = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
require("./DateField.scss");
var _reactCalendar = _interopRequireDefault(require("react-calendar"));
var _moment = _interopRequireDefault(require("moment"));
var _isNullOrUndefined = _interopRequireDefault(require("../Functions/isNullOrUndefined"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DATE_FORMAT = "YYYY-MM-DD";
exports.DATE_FORMAT = DATE_FORMAT;
var DateField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DateField, _Component);
  var _super = (0, _createSuper2.default)(DateField);
  function DateField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DateField);
    _this = _super.call(this, props);
    var dates = props.date ? props.date.split("-") : [];
    _this.state = {
      day: dates[2] || "",
      month: dates[1] || "",
      year: dates[0] || "",
      calendarShowing: false
      // isErrorShowing: false,
    };

    _this.limits = {
      day: 2,
      month: 2,
      year: 4
    };
    _this.trigger = /*#__PURE__*/_react.default.createRef();
    _this.dayField = /*#__PURE__*/_react.default.createRef();
    _this.monthField = /*#__PURE__*/_react.default.createRef();
    _this.yearField = /*#__PURE__*/_react.default.createRef();
    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
    _this.dateFromCalendar = _this.dateFromCalendar.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDayChange = _this.onDayChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateChange = _this.onDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValidity = _this.getValidity.bind((0, _assertThisInitialized2.default)(_this));
    _this.update = _this.update.bind((0, _assertThisInitialized2.default)(_this));
    _this.padValues = _this.padValues.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DateField, [{
    key: "toggle",
    value: function toggle(field) {
      return this.setState(function (prevState) {
        return (0, _defineProperty2.default)({}, field, !prevState[field]);
      });
    }
  }, {
    key: "dateFromCalendar",
    value: function dateFromCalendar(date) {
      var _this2 = this;
      this.setState({
        calendarShowing: false,
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
      }, function () {
        return _this2.update(true);
      });
    }
  }, {
    key: "onDayChange",
    value: function onDayChange(event) {
      //TODO figure out max day based on month;
      var maxDay = 31;
      var rawValue = event.target.value.replace(/[^0-9]+/g, "");
      var parsedValue = parseInt(rawValue);
      if (parsedValue > maxDay) return;
      this.onDateChange("day", rawValue, null, this.monthField, this.onMonthChange);
    }
  }, {
    key: "onMonthChange",
    value: function onMonthChange(event) {
      var maxMonth = 12;
      var rawValue = event.target.value.replace(/[^0-9]+/g, "");
      var parsedValue = parseInt(rawValue);
      if (parsedValue > maxMonth) return;
      this.onDateChange("month", rawValue, this.dayField, this.yearField, this.onYearChange);
    }
  }, {
    key: "onYearChange",
    value: function onYearChange(event) {
      this.onDateChange("year", event.target.value.replace(/[^0-9]+/g, ""), this.monthField);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.stateShouldUpdateWhenPropsChange && prevProps.date !== this.props.date) {
        if (this.props.date !== this.getDateString()) {
          if ((0, _isNullOrUndefined.default)(this.props.date) || this.props.date === "") {
            this.setState({
              day: "",
              month: "",
              year: ""
            });
          }
          if (this.props.acceptsNonNullPropsValues) {
            var dates = this.props.date ? this.props.date.split("-") : [];
            this.setState({
              day: dates[2],
              month: dates[1],
              year: dates[0]
            });
          }
        }
      }
    }
  }, {
    key: "onDateChange",
    value: function onDateChange(field, value, back, next, onOverFlow) {
      var limit = this.limits[field];
      if (value.length === 0 && back) {
        back.current.focus();
      } else if (value.length >= limit && next) {
        next.current.focus();
        if (value.length > limit && onOverFlow) {
          onOverFlow({
            target: {
              value: value.substring(limit)
            }
          });
        }
      }
      this.setState((0, _defineProperty2.default)({}, field, value.substring(0, limit)), this.update);
    }
  }, {
    key: "getDateString",
    value: function getDateString() {
      var _this$state = this.state,
        day = _this$state.day,
        month = _this$state.month,
        year = _this$state.year;
      return "".concat(year, "-").concat(month, "-").concat(day);
    }
  }, {
    key: "getValidity",
    value: function getValidity() {
      var _this$state2 = this.state,
        day = _this$state2.day,
        month = _this$state2.month,
        year = _this$state2.year;
      var getErrorMessage = this.props.getErrorMessage;
      if (!day || !month || !year || !(0, _moment.default)(this.getDateString(), DATE_FORMAT).isValid()) {
        return {
          errorMessage: "Not a valid date",
          isValid: false
        };
      } else if (getErrorMessage) {
        var errorMessage = getErrorMessage(this.getDateString());
        if (errorMessage) {
          return {
            errorMessage: errorMessage,
            isValid: false
          };
        }
      }
      return {
        errorMessage: null,
        isValid: true
      };
    }
  }, {
    key: "update",
    value: function update(dateFromCalendar) {
      if (this.props.onChange) {
        if (this.getValidity().isValid) {
          this.props.onChange((0, _moment.default)(this.getDateString(), DATE_FORMAT).format(DATE_FORMAT), dateFromCalendar);
        } else if (!this.props.stateShouldUpdateWhenPropsChange) {
          this.props.onChange(null);
        }
      }
    }
  }, {
    key: "padValues",
    value: function padValues() {
      var _this3 = this;
      this.setState(function (prevState) {
        if (prevState.day !== "") {
          if (prevState.day.toString) {
            prevState.day = prevState.day.toString();
          }
          if (prevState.day.padStart) {
            prevState.day = prevState.day.padStart(_this3.limits.day, "0");
          }
        }
        if (prevState.month !== "") {
          if (prevState.month.toString) {
            prevState.month = prevState.month.toString();
          }
          if (prevState.month.padStart) {
            prevState.month = prevState.month.padStart(_this3.limits.month, "0");
          }
        }
        if (prevState.year !== "") {
          if (prevState.year.toString) {
            prevState.year = prevState.year.toString();
          }
          if (prevState.year.padStart) {
            prevState.year = prevState.year.padStart(_this3.limits.year, "0");
          }
        }
        return prevState;
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      this.padValues();
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.setState({
          calendarShowing: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state3 = this.state,
        day = _this$state3.day,
        month = _this$state3.month,
        year = _this$state3.year,
        calendarShowing = _this$state3.calendarShowing;
      var _this$props = this.props,
        id = _this$props.id,
        autoFocus = _this$props.autoFocus,
        IconOverride = _this$props.IconOverride,
        disabled = _this$props.disabled,
        placeholder = _this$props.placeholder,
        _onKeyDown = _this$props.onKeyDown,
        onViewChange = _this$props.onViewChange,
        onClickDay = _this$props.onClickDay,
        onClickDecade = _this$props.onClickDecade,
        onClickMonth = _this$props.onClickMonth,
        onClickWeekNumber = _this$props.onClickWeekNumber,
        onClickYear = _this$props.onClickYear,
        onDrillDown = _this$props.onDrillDown,
        onDrillUp = _this$props.onDrillUp;
      var _this$getValidity = this.getValidity(),
        isValid = _this$getValidity.isValid;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        style: this.props.style,
        className: "date-field-outer ".concat(disabled ? " date-field-outer-disabled" : "") /*+ (!isErrorShowing || isValid ? "" : " input-validation-text-invalid")*/,
        tabIndex: "-1",
        onBlur: this.onBlur /*() => this.setState({ isErrorShowing: true })*/,
        id: id && "".concat(id, "-date-field-outer")
      }, IconOverride ? /*#__PURE__*/_react.default.cloneElement(IconOverride, {
        className: "calendar-trigger",
        ref: this.trigger,
        onClick: function onClick() {
          _this4.toggle("calendarShowing");
        },
        id: id && "".concat(id, "-date-field-calendar-icon")
      }) : /*#__PURE__*/_react.default.createElement("i", {
        id: id && "".concat(id, "-date-field-calendar-icon"),
        className: "material-icons calendar-trigger ".concat(disabled ? "calendar-trigger-disabled" : ""),
        ref: this.trigger,
        onClick: function onClick() {
          _this4.toggle("calendarShowing");
        }
      }, "date_range"), /*#__PURE__*/_react.default.createElement("div", {
        className: "calendar-wrapper" + (calendarShowing && !disabled ? " calendar-wrapper-showing" : "")
      }, /*#__PURE__*/_react.default.createElement(_reactCalendar.default, {
        value: isValid ? new Date(year, month - 1, day) : new Date(),
        onChange: this.dateFromCalendar,
        nextLabel: "\u203A",
        next2Label: "\xBB",
        prevLabel: "\u2039",
        prev2Label: "\xAB",
        onViewChange: onViewChange,
        onClickDay: onClickDay,
        onClickDecade: onClickDecade,
        onClickMonth: onClickMonth,
        onClickWeekNumber: onClickWeekNumber,
        onClickYear: onClickYear,
        onDrillDown: onDrillDown,
        onDrillUp: onDrillUp
      })), /*#__PURE__*/_react.default.createElement("input", {
        disabled: disabled,
        id: id && "".concat(id, "-day"),
        className: "date-field-field ".concat(disabled ? " date-field-field-disabled" : ""),
        value: day,
        onChange: this.onDayChange,
        ref: this.dayField,
        placeholder: placeholder && placeholder.day ? placeholder.day : "00",
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown(e, "day");
        },
        autoFocus: autoFocus ? true : false
      }), "/", /*#__PURE__*/_react.default.createElement("input", {
        disabled: disabled,
        id: id && "".concat(id, "-month"),
        className: "date-field-field ".concat(disabled ? " date-field-field-disabled" : ""),
        value: month,
        onChange: this.onMonthChange,
        ref: this.monthField,
        placeholder: placeholder && placeholder.month ? placeholder.month : "00",
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown(e, "month");
        }
      }), "/", /*#__PURE__*/_react.default.createElement("input", {
        disabled: disabled,
        id: id && "".concat(id, "-year"),
        className: "date-field-field date-field-year ".concat(disabled ? " date-field-field-disabled" : ""),
        value: year,
        onChange: this.onYearChange,
        ref: this.yearField,
        placeholder: placeholder && placeholder.year ? placeholder.year : "0000",
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown(e, "year");
        }
      })));
    }
  }]);
  return DateField;
}(_react.Component);
var _default = DateField;
exports.default = _default;